// select a2, rname from country  where a2 is not null order by rname
// 2023-03-24
export default [
	{
		"id" : "RU",
		"name" : "Россия"
	},
	{
		"id" : "BY",
		"name" : "Беларусь"
	},
	{
		"id" : "KZ",
		"name" : "Казахстан"
	},
	{
		"id" : "AB",
		"name" : "Абхазия"
	},
	{
		"id" : "AU",
		"name" : "Австралия"
	},
	{
		"id" : "AT",
		"name" : "Австрия"
	},
	{
		"id" : "AZ",
		"name" : "Азербайджан"
	},
	{
		"id" : "AL",
		"name" : "Албания"
	},
	{
		"id" : "DZ",
		"name" : "Алжир"
	},
	{
		"id" : "AS",
		"name" : "Американское Самоа"
	},
	{
		"id" : "AI",
		"name" : "Ангилья"
	},
	{
		"id" : "AO",
		"name" : "Ангола"
	},
	{
		"id" : "AD",
		"name" : "Андорра"
	},
	{
		"id" : "AQ",
		"name" : "Антарктида"
	},
	{
		"id" : "AG",
		"name" : "Антигуа и Барбуда"
	},
	{
		"id" : "AR",
		"name" : "Аргентина"
	},
	{
		"id" : "AM",
		"name" : "Армения"
	},
	{
		"id" : "AW",
		"name" : "Аруба"
	},
	{
		"id" : "AF",
		"name" : "Афганистан"
	},
	{
		"id" : "BS",
		"name" : "Багамы"
	},
	{
		"id" : "BD",
		"name" : "Бангладеш"
	},
	{
		"id" : "BB",
		"name" : "Барбадос"
	},
	{
		"id" : "BH",
		"name" : "Бахрейн"
	},
	{
		"id" : "BZ",
		"name" : "Белиз"
	},
	{
		"id" : "BE",
		"name" : "Бельгия"
	},
	{
		"id" : "BJ",
		"name" : "Бенин"
	},
	{
		"id" : "BM",
		"name" : "Бермуды"
	},
	{
		"id" : "BG",
		"name" : "Болгария"
	},
	{
		"id" : "BO",
		"name" : "Боливия"
	},
	{
		"id" : "BQ",
		"name" : "Бонэйр, Синт-Эстатиус И Саба"
	},
	{
		"id" : "BA",
		"name" : "Босния и Герцеговина"
	},
	{
		"id" : "BW",
		"name" : "Ботсвана"
	},
	{
		"id" : "BR",
		"name" : "Бразилия"
	},
	{
		"id" : "IO",
		"name" : "Британская Территория в Индийском Океане"
	},
	{
		"id" : "BN",
		"name" : "Бруней-Даруссалам"
	},
	{
		"id" : "BF",
		"name" : "Буркина-Фасо"
	},
	{
		"id" : "BI",
		"name" : "Бурунди"
	},
	{
		"id" : "BT",
		"name" : "Бутан"
	},
	{
		"id" : "VU",
		"name" : "Вануату"
	},
	{
		"id" : "GB",
		"name" : "Великобритания"
	},
	{
		"id" : "HU",
		"name" : "Венгрия"
	},
	{
		"id" : "VE",
		"name" : "Венесуэла"
	},
	{
		"id" : "VG",
		"name" : "Виргинские Британские Острова"
	},
	{
		"id" : "VI",
		"name" : "Виргинские Острова, Сша"
	},
	{
		"id" : "VN",
		"name" : "Вьетнам"
	},
	{
		"id" : "GA",
		"name" : "Габон"
	},
	{
		"id" : "HT",
		"name" : "Гаити"
	},
	{
		"id" : "GY",
		"name" : "Гайана"
	},
	{
		"id" : "GM",
		"name" : "Гамбия"
	},
	{
		"id" : "GH",
		"name" : "Гана"
	},
	{
		"id" : "GP",
		"name" : "Гваделупа"
	},
	{
		"id" : "GT",
		"name" : "Гватемала"
	},
	{
		"id" : "GN",
		"name" : "Гвинея"
	},
	{
		"id" : "GW",
		"name" : "Гвинея-Бисау"
	},
	{
		"id" : "DE",
		"name" : "Германия"
	},
	{
		"id" : "GG",
		"name" : "Гернси"
	},
	{
		"id" : "GI",
		"name" : "Гибралтар"
	},
	{
		"id" : "HN",
		"name" : "Гондурас"
	},
	{
		"id" : "HK",
		"name" : "Гонконг"
	},
	{
		"id" : "GD",
		"name" : "Гренада"
	},
	{
		"id" : "GL",
		"name" : "Гренландия"
	},
	{
		"id" : "GR",
		"name" : "Греция"
	},
	{
		"id" : "GE",
		"name" : "Грузия"
	},
	{
		"id" : "GU",
		"name" : "Гуам"
	},
	{
		"id" : "DK",
		"name" : "Дания"
	},
	{
		"id" : "CD",
		"name" : "Демократическая Республика Конго"
	},
	{
		"id" : "JE",
		"name" : "Джерси"
	},
	{
		"id" : "DJ",
		"name" : "Джибути"
	},
	{
		"id" : "DM",
		"name" : "Доминика"
	},
	{
		"id" : "DO",
		"name" : "Доминикана"
	},
	{
		"id" : "EG",
		"name" : "Египет"
	},
	{
		"id" : "ZM",
		"name" : "Замбия"
	},
	{
		"id" : "EH",
		"name" : "Западная Сахара"
	},
	{
		"id" : "ZW",
		"name" : "Зимбабве"
	},
	{
		"id" : "IL",
		"name" : "Израиль"
	},
	{
		"id" : "IN",
		"name" : "Индия"
	},
	{
		"id" : "ID",
		"name" : "Индонезия"
	},
	{
		"id" : "JO",
		"name" : "Иордания"
	},
	{
		"id" : "IQ",
		"name" : "Ирак"
	},
	{
		"id" : "IR",
		"name" : "Иран"
	},
	{
		"id" : "IE",
		"name" : "Ирландия"
	},
	{
		"id" : "IS",
		"name" : "Исландия"
	},
	{
		"id" : "ES",
		"name" : "Испания"
	},
	{
		"id" : "IT",
		"name" : "Италия"
	},
	{
		"id" : "YE",
		"name" : "Йемен"
	},
	{
		"id" : "CV",
		"name" : "Кабо-Верде"
	},
	{
		"id" : "KH",
		"name" : "Камбоджа"
	},
	{
		"id" : "CM",
		"name" : "Камерун"
	},
	{
		"id" : "CA",
		"name" : "Канада"
	},
	{
		"id" : "QA",
		"name" : "Катар"
	},
	{
		"id" : "KE",
		"name" : "Кения"
	},
	{
		"id" : "CY",
		"name" : "Кипр"
	},
	{
		"id" : "KG",
		"name" : "Киргизия"
	},
	{
		"id" : "KI",
		"name" : "Кирибати"
	},
	{
		"id" : "CN",
		"name" : "Китай"
	},
	{
		"id" : "CC",
		"name" : "Кокосовые (Килинг) Острова"
	},
	{
		"id" : "CO",
		"name" : "Колумбия"
	},
	{
		"id" : "KM",
		"name" : "Коморы"
	},
	{
		"id" : "CG",
		"name" : "Конго"
	},
	{
		"id" : "KP",
		"name" : "Корея, Народно-Демократическая Республика"
	},
	{
		"id" : "CR",
		"name" : "Коста-Рика"
	},
	{
		"id" : "CI",
		"name" : "Кот Д'Ивуар"
	},
	{
		"id" : "CU",
		"name" : "Куба"
	},
	{
		"id" : "KW",
		"name" : "Кувейт"
	},
	{
		"id" : "AN",
		"name" : "Кюрасао"
	},
	{
		"id" : "LA",
		"name" : "Лаосская Народно-Демократическая Республика"
	},
	{
		"id" : "LV",
		"name" : "Латвия"
	},
	{
		"id" : "LS",
		"name" : "Лесото"
	},
	{
		"id" : "LR",
		"name" : "Либерия"
	},
	{
		"id" : "LB",
		"name" : "Ливан"
	},
	{
		"id" : "LY",
		"name" : "Ливия"
	},
	{
		"id" : "LT",
		"name" : "Литва"
	},
	{
		"id" : "LI",
		"name" : "Лихтенштейн"
	},
	{
		"id" : "LU",
		"name" : "Люксембург"
	},
	{
		"id" : "MU",
		"name" : "Маврикий"
	},
	{
		"id" : "MR",
		"name" : "Мавритания"
	},
	{
		"id" : "MG",
		"name" : "Мадагаскар"
	},
	{
		"id" : "YT",
		"name" : "Майотта"
	},
	{
		"id" : "MO",
		"name" : "Макао"
	},
	{
		"id" : "MW",
		"name" : "Малави"
	},
	{
		"id" : "MY",
		"name" : "Малайзия"
	},
	{
		"id" : "ML",
		"name" : "Мали"
	},
	{
		"id" : "UM",
		"name" : "Малые Тихоокеанские Отдаленные Острова Соединенных Штатов"
	},
	{
		"id" : "MV",
		"name" : "Мальдивы"
	},
	{
		"id" : "MT",
		"name" : "Мальта"
	},
	{
		"id" : "MA",
		"name" : "Марокко"
	},
	{
		"id" : "MQ",
		"name" : "Мартиника"
	},
	{
		"id" : "MH",
		"name" : "Маршалловы Острова"
	},
	{
		"id" : "MX",
		"name" : "Мексика"
	},
	{
		"id" : "FM",
		"name" : "Микронезия"
	},
	{
		"id" : "MZ",
		"name" : "Мозамбик"
	},
	{
		"id" : "MD",
		"name" : "Молдавия"
	},
	{
		"id" : "MC",
		"name" : "Монако"
	},
	{
		"id" : "MN",
		"name" : "Монголия"
	},
	{
		"id" : "MS",
		"name" : "Монтсеррат"
	},
	{
		"id" : "MM",
		"name" : "Мьянма"
	},
	{
		"id" : "NA",
		"name" : "Намибия"
	},
	{
		"id" : "NR",
		"name" : "Науру"
	},
	{
		"id" : "NP",
		"name" : "Непал"
	},
	{
		"id" : "NE",
		"name" : "Нигер"
	},
	{
		"id" : "NG",
		"name" : "Нигерия"
	},
	{
		"id" : "NL",
		"name" : "Нидерланды"
	},
	{
		"id" : "NI",
		"name" : "Никарагуа"
	},
	{
		"id" : "NU",
		"name" : "Ниуэ"
	},
	{
		"id" : "NZ",
		"name" : "Новая Зеландия"
	},
	{
		"id" : "NC",
		"name" : "Новая Каледония"
	},
	{
		"id" : "NO",
		"name" : "Норвегия"
	},
	{
		"id" : "AE",
		"name" : "ОАЭ"
	},
	{
		"id" : "OM",
		"name" : "Оман"
	},
	{
		"id" : "KY",
		"name" : "Острова Кайман"
	},
	{
		"id" : "CK",
		"name" : "Острова Кука"
	},
	{
		"id" : "TC",
		"name" : "Острова Теркс И Кайкос"
	},
	{
		"id" : "BV",
		"name" : "Остров Буве"
	},
	{
		"id" : "IM",
		"name" : "Остров Мэн"
	},
	{
		"id" : "NF",
		"name" : "Остров Норфолк"
	},
	{
		"id" : "CX",
		"name" : "Остров Рождества"
	},
	{
		"id" : "HM",
		"name" : "Остров Херд И Острова Макдональд"
	},
	{
		"id" : "PK",
		"name" : "Пакистан"
	},
	{
		"id" : "PW",
		"name" : "Палау"
	},
	{
		"id" : "PS",
		"name" : "Палестина, Государство"
	},
	{
		"id" : "PA",
		"name" : "Панама"
	},
	{
		"id" : "VA",
		"name" : "Папский Престол (Государство - Город Ватикан)"
	},
	{
		"id" : "PG",
		"name" : "Папуа-Новая Гвинея"
	},
	{
		"id" : "PY",
		"name" : "Парагвай"
	},
	{
		"id" : "PE",
		"name" : "Перу"
	},
	{
		"id" : "PN",
		"name" : "Питкерн"
	},
	{
		"id" : "PL",
		"name" : "Польша"
	},
	{
		"id" : "PT",
		"name" : "Португалия"
	},
	{
		"id" : "PR",
		"name" : "Пуэрто-Рико"
	},
	{
		"id" : "MK",
		"name" : "Республика Македония[2]"
	},
	{
		"id" : "RE",
		"name" : "Реюньон"
	},
	{
		"id" : "RW",
		"name" : "Руанда"
	},
	{
		"id" : "RO",
		"name" : "Румыния"
	},
	{
		"id" : "WS",
		"name" : "Самоа"
	},
	{
		"id" : "SM",
		"name" : "Сан-Марино"
	},
	{
		"id" : "ST",
		"name" : "Сан-Томе И Принсипи"
	},
	{
		"id" : "SA",
		"name" : "Саудовская Аравия"
	},
	{
		"id" : "SZ",
		"name" : "Свазиленд"
	},
	{
		"id" : "SH",
		"name" : "Святая Елена, Остров Вознесения, Тристан-Да-Кунья"
	},
	{
		"id" : "MP",
		"name" : "Северные Марианские Острова"
	},
	{
		"id" : "SC",
		"name" : "Сейшелы"
	},
	{
		"id" : "BL",
		"name" : "Сен-Бартелеми"
	},
	{
		"id" : "SN",
		"name" : "Сенегал"
	},
	{
		"id" : "MF",
		"name" : "Сен-Мартен"
	},
	{
		"id" : "SX",
		"name" : "Сен-Мартен (Нидерландская Часть)"
	},
	{
		"id" : "PM",
		"name" : "Сен-Пьер И Микелон"
	},
	{
		"id" : "VC",
		"name" : "Сент-Винсент И Гренадины"
	},
	{
		"id" : "KN",
		"name" : "Сент-Китс И Невис"
	},
	{
		"id" : "LC",
		"name" : "Сент-Люсия"
	},
	{
		"id" : "RS",
		"name" : "Сербия"
	},
	{
		"id" : "SG",
		"name" : "Сингапур"
	},
	{
		"id" : "SY",
		"name" : "Сирийская Арабская Республика"
	},
	{
		"id" : "SK",
		"name" : "Словакия"
	},
	{
		"id" : "SI",
		"name" : "Словения"
	},
	{
		"id" : "SB",
		"name" : "Соломоновы Острова"
	},
	{
		"id" : "SO",
		"name" : "Сомали"
	},
	{
		"id" : "SD",
		"name" : "Судан"
	},
	{
		"id" : "SR",
		"name" : "Суринам"
	},
	{
		"id" : "US",
		"name" : "США"
	},
	{
		"id" : "SL",
		"name" : "Сьерра-Леоне"
	},
	{
		"id" : "TJ",
		"name" : "Таджикистан"
	},
	{
		"id" : "TH",
		"name" : "Таиланд"
	},
	{
		"id" : "TW",
		"name" : "Тайвань (Китай)"
	},
	{
		"id" : "TZ",
		"name" : "Танзания"
	},
	{
		"id" : "TL",
		"name" : "Тимор-Лесте"
	},
	{
		"id" : "TG",
		"name" : "Того"
	},
	{
		"id" : "TK",
		"name" : "Токелау"
	},
	{
		"id" : "TO",
		"name" : "Тонга"
	},
	{
		"id" : "TT",
		"name" : "Тринидад И Тобаго"
	},
	{
		"id" : "TV",
		"name" : "Тувалу"
	},
	{
		"id" : "TN",
		"name" : "Тунис"
	},
	{
		"id" : "TM",
		"name" : "Туркмения"
	},
	{
		"id" : "TR",
		"name" : "Турция"
	},
	{
		"id" : "UG",
		"name" : "Уганда"
	},
	{
		"id" : "UZ",
		"name" : "Узбекистан"
	},
	{
		"id" : "UA",
		"name" : "Украина"
	},
	{
		"id" : "WF",
		"name" : "Уоллис И Футуна"
	},
	{
		"id" : "UY",
		"name" : "Уругвай"
	},
	{
		"id" : "FO",
		"name" : "Фарерские Острова"
	},
	{
		"id" : "FJ",
		"name" : "Фиджи"
	},
	{
		"id" : "PH",
		"name" : "Филиппины"
	},
	{
		"id" : "FI",
		"name" : "Финляндия"
	},
	{
		"id" : "FK",
		"name" : "Фолклендские Острова (Мальвинские)"
	},
	{
		"id" : "FR",
		"name" : "Франция"
	},
	{
		"id" : "GF",
		"name" : "Французская Гвиана"
	},
	{
		"id" : "PF",
		"name" : "Французская Полинезия"
	},
	{
		"id" : "TF",
		"name" : "Французские Южные Территории"
	},
	{
		"id" : "HR",
		"name" : "Хорватия"
	},
	{
		"id" : "CF",
		"name" : "Центрально-Африканская Республика"
	},
	{
		"id" : "TD",
		"name" : "Чад"
	},
	{
		"id" : "ME",
		"name" : "Черногория"
	},
	{
		"id" : "CZ",
		"name" : "Чехия"
	},
	{
		"id" : "CL",
		"name" : "Чили"
	},
	{
		"id" : "CH",
		"name" : "Швейцария"
	},
	{
		"id" : "SE",
		"name" : "Швеция"
	},
	{
		"id" : "SJ",
		"name" : "Шпицберген И Ян Майен"
	},
	{
		"id" : "LK",
		"name" : "Шри-Ланка"
	},
	{
		"id" : "EC",
		"name" : "Эквадор"
	},
	{
		"id" : "GQ",
		"name" : "Экваториальная Гвинея"
	},
	{
		"id" : "AX",
		"name" : "Эландские Острова"
	},
	{
		"id" : "SV",
		"name" : "Эль-Сальвадор"
	},
	{
		"id" : "ER",
		"name" : "Эритрея"
	},
	{
		"id" : "EE",
		"name" : "Эстония"
	},
	{
		"id" : "ET",
		"name" : "Эфиопия"
	},
	{
		"id" : "ZA",
		"name" : "ЮАР"
	},
	{
		"id" : "GS",
		"name" : "Южная Джорджия И Южные Сандвичевы Острова"
	},
	{
		"id" : "KR",
		"name" : "Южная Корея"
	},
	{
		"id" : "OS",
		"name" : "Южная Осетия"
	},
	{
		"id" : "SS",
		"name" : "Южный Судан"
	},
	{
		"id" : "JM",
		"name" : "Ямайка"
	},
	{
		"id" : "JP",
		"name" : "Япония"
	}
]


